import { ESCAPE_REGEX_SEARCH } from './_consts';
export default function escapeRegExp(str) {
    return str.replace(ESCAPE_REGEX_SEARCH, "\\$&");
}
